/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { MatDialogConfig } from '@angular/material/dialog';
import { LanguageCodeHelper } from '../language-code-helper';

/** Width a V3 dialog takes unless it asks for another. */
const V3_DIALOG_WIDTH = '37.5rem';

/**
 * Chrome shared by every V3 dialog — panel, backdrop, placement, direction — so a caller states only
 * what is particular to its dialog. Lives apart from `V3DialogService` because that service pulls in
 * dialog components, and importing it from anything `SharedModule` declares closes an import cycle.
 */
export function v3DialogConfig<D>(overrides: Partial<MatDialogConfig<D>> = {}): MatDialogConfig<D> {
  return {
    width: V3_DIALOG_WIDTH,
    maxHeight: '80vh',
    restoreFocus: true,
    position: { top: '10vh' },
    direction: LanguageCodeHelper.getBodyLanguageDir(),
    panelClass: 'ptl-v3-dialog',
    backdropClass: 'ptl-v3-dialog-backdrop-default',
    ...overrides,
  } as MatDialogConfig<D>;
}
